
export default {
    install: (Vue, options) => {
        Vue.config.globalProperties.$message = function (html) {
            M.toast({html: html});
        }
        
        Vue.config.globalProperties.$error = function(html){
            M.toast({html: `[Ошибка]: ${html}`});
        }
    }
}